import "./Map.css";
import React, { useEffect, useState } from "react";
import Uk from "@svg-maps/ukraine";
import { SVGMap } from "react-svg-map";
import "react-svg-map/lib/index.css";
import Projects from "./Projects";
import Ukraine from "../../assets/ukraine.png";
import { t } from "i18next";
import axios from "axios";

export default function Map() {
  let [stateCode, setStateCode] = useState("kherson");
  let [projects, setProjects] = useState([]);
  let [stateData, setStateData] = useState([]);

  function findProjectsbyRegion(projects) {
    const formattedRegionCode = formatRegionName(stateCode);
    return projects.filter((project) =>
      project.regions?.some(
        (region) => formatRegionName(region) === formattedRegionCode
      )
    );
  }

  function formatRegionName(name) {
    if (name === "dnipropetrovsk" || name === "Dnipropetrovsk") {
      return "Dnipro";
    }
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  }

  function onLocationClick(event) {
    if (
      event.target.id === "dnipropetrovsk" ||
      event.target.id === "Dnipropetrovsk"
    ) {
      setStateCode("Dnipro");
    } else {
      setStateCode(event.target.id);
    }
  }


  useEffect(() => {
    axios.get(process.env.REACT_APP_BACKEND_LINK + `/projects/`).then((response) => {
      const normalized = response.data.map((project) => {
        const regions = (project.region || "").split("\n").map(r => r.trim());
        return { ...project, regions }; // додамо окремо regions як масив
      });
    
      setProjects(normalized);
    
      const dataRegion = findProjectsbyRegion(normalized);
      setStateData(dataRegion);
    });
  }, [stateCode]);

  return (
    <div className="MapHelp">
      <h3 className="section-title-text py-5">
        <div className="title-line"></div>
        {t("map title")}
      </h3>
      <p> {t("map p")}</p>
      <div className="MapUkr">
        <div className="map-pic">
          <div className="ukraine">
            <img src={Ukraine} alt="ukraine" />
          </div>
          <SVGMap
            map={Uk}
            onLocationClick={onLocationClick}
            locationClassName={(location) => {
              const regionId = location.name;
              const formattedRegion = formatRegionName(regionId);
            
              const isProjectRegion = projects.some((project) => {
                const match = project.regions?.some(
                  (region) => formatRegionName(region) === formattedRegion
                );
            
                console.log(match ? `✅ MATCH: ${formattedRegion}` : `❌ NO MATCH: ${formattedRegion}`, project.regions);
            
                return match;
              });
            
              return isProjectRegion ? "project-region" : "";
            }}
            
          />
        </div>
        <div className="map-info">
          <h3>{t("map projects title")}</h3>
          <h3>{t(stateCode)}</h3>
          <div className="projects-info">
            <Projects info={stateData} />
          </div>
        </div>
      </div>
    </div>
  );
}
